export const DEFAULT_NAVBAR = "DEFAULT_NAVBAR";
export const LANDING_NAVBAR = "LANDING_NAVBAR";
export const CLUB_NAVBAR = "CLUB_NAVBAR";
export const EMPTY_NAVBAR = "EMPTY_NAVBAR";
export const PORTAL_NAVBAR = "PORTAL_NAVBAR";
